import {Column} from '@valg-shared/components/table/table/column';
import {CheckboxOption} from '@valg-shared/components/input/checkbox-group/checkbox-option';

export interface TableFilterDialogData {
  title?: string;
  description?: string;
  columns: TableFilterDialogColumnData[];
  dataPath?: string;
  buttonTitle?: string;
}

export interface TableFilterDialogColumnData {
  column: Column;
  preSelectedOptions?: CheckboxOption[];
  value?: (string | number)[];
  preSelected: (string | number)[];
}

export interface TableFilterDialogResult {
  columns: TableFilterDialogResultData[];
}

export interface TableFilterDialogResultData {
  column: Column;
  value: unknown[];
}

export interface TableFilterDialogSelectionData {
  column: Column;
  value: CheckboxOption[];
  filterType?: FilterType
}

export enum FilterType{
  checkbox,
  string,
  postalcode,
  date
}
